define('NVT.anuualupdateform.org_cont_instruction.View'
, [
    'Backbone'
  , 'nvt_org_cont_instruction.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_org_cont_instruction_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           

        template: nvt_org_cont_instruction_tpl

       , title: Utils.translate('Instructions')


        ,initialize: function(options)
            {
                this.options = options;
                this.profile= options.profile;
                this.application = options.application;
                this.page_header = Utils.translate('Instructions');
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }
            
        ,getContext: function() {
            
            return {
               title : this.page_header
              
           }
         }        

    });
});
